import { httpRequest } from "../../http";

export class CommandDeleteScheduleSegment {
    async run(segmentId: number) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/schedules/segments/${segmentId}`
       
        try {
            await httpRequest<any>(url, { method: "DELETE" });
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

}



